import { CircularProgress, Paper, Typography } from '@mui/material';
import { BASIC_BORDER_COLOR } from '../../../themes/tokens';
import ArrowDownwardRoundedIcon from '@mui/icons-material/ArrowDownwardRounded';
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import { KpiData } from '../../../pages/SalonDashboard/types';
import { useTranslation } from 'react-i18next';

type Props = {
  label: string;
  data?: { value: number | string; prefix?: string | null; suffix?: string | null };
  showPlaceholder?: boolean;
  prevData?: KpiData['previousDateRange']['value']['raw'];
  isLoading?: boolean;
};

export const SingleKpiBlock = ({ label, data, showPlaceholder, prevData, isLoading }: Props) => {
  const { t } = useTranslation();

  return (
    <Paper
      elevation={0}
      sx={{
        width: '100%',
        minHeight: '180px',
        height: '100%',
        p: 2,
        borderRadius: '8px',
        bgcolor: '#f8f7f6',
        border: `1px solid ${BASIC_BORDER_COLOR}`,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        textAlign: 'center',
        gap: '10px',
        padding: '16px 8px',
      }}
    >
      <Typography variant="h6">{label}</Typography>
      <Typography
        variant="h5"
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        {data ? (
          <>
            {data.prefix || ''}
            {data.value}
            {data.suffix || ''}
            {prevData?.value &&
              typeof data.value === 'number' &&
              (prevData.value < data.value ? (
                <ArrowUpwardRoundedIcon fontSize="large" color="success" />
              ) : prevData.value > data.value ? (
                <ArrowDownwardRoundedIcon fontSize="large" color="error" />
              ) : null)}
          </>
        ) : isLoading ? (
          <CircularProgress size={20} />
        ) : showPlaceholder ? (
          ''
        ) : (
          t('noData')
        )}
      </Typography>
    </Paper>
  );
};
